import React, { useState, useEffect } from "react";
import { useTimesheets } from "../customHooks/useTimesheets";
// import { OperativesContext } from "../providers/OperativesProvider";
// import { TimesheetsContext } from "../providers/TimesheetsProvider";
import { section } from "../helperFunctions/sortAndFilterFunctions";
import { timesheetsRef, quotesRef } from "../firebase";
import { calcJobsMaterials } from "../helperFunctions/calculationFunctions";
import Footer from "./Footer";
// import { Parser } from "json2csv";
import { Parser } from "@json2csv/plainjs";

import "../css/export.scss";
import { getDbRef } from "../helperFunctions/determineType";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import { collection, getDocs } from "firebase/firestore";

const markedTimesheet = { background: "var(--grey" };
const unmarkedTimesheet = { background: "none" };

let timesheetFields = {
  fields: [
    {
      label: "A - blank",
      value: "blank",
    },
    {
      label: "B - refNumber",
      value: "refNumber",
    },
    {
      label: "C - accessId",
      value: "accessId",
    },
    {
      label: "D - worksOrderNumber",
      value: "worksOrderNumber",
    },
    {
      label: "E - jobLocation",
      value: "jobLocation",
    },
    {
      label: "F - authorisedBy",
      value: "authorisedBy",
    },
    {
      label: "G - invoiceDate",
      value: "invoiceDate",
    },
    {
      label: "H - jobReceived",
      value: "jobReceived",
    },
    {
      label: "I - jobStart",
      value: "jobStart",
    },
    {
      label: "J - jobEnd",
      value: "jobEnd",
    },
    {
      label: "K - jobDetails",
      value: "jobDetails",
    },
    {
      label: "L - hours",
      value: "hours",
    },
    {
      label: "M - multiplier",
      value: "multiplier",
    },
    {
      label: "N - discount",
      value: "discount",
    },
    {
      label: "O - hourRate",
      value: "hourRate",
    },
    {
      label: "P - materialsCost",
      value: "materialsCost",
    },
    {
      label: "Q - paid",
      value: "paid",
    },
    {
      label: "R - datePaid",
      value: "datePaid",
    },
    {
      label: "S - printSelector",
      value: "printSelector",
    },
    {
      label: "T - dateSent",
      value: "dateSent",
    },
  ],
};

let materialsFields = {
  fields: [
    {
      label: "A - blank",
      value: "blank",
    },
    {
      label: "B - invoiceCode",
      value: "invoiceCode",
    },
    {
      label: "C - materialDescription",
      value: "materialDescription",
    },
    {
      label: "D - quantity",
      value: "quantity",
    },
    {
      label: "E - itemRefPrice",
      value: "itemRefPrice",
    },
  ],
};

function getAssociatedMaterials(timesheets) {
  let materialsData = timesheets.map((ts) => {
    let { jobDescriptions = [], refNumber, uid, priceDifference } = ts;

    // if (quotePrice) {
    //   return {
    //     category: "Quoted Price",
    //     invoiceCode: refNumber,
    //     itemRefPrice: quotePrice,
    //     materialCode: uid,
    //     materialDescription: "As Per Quote",
    //     quantity: 1,
    //   };
    // }

    let materialsToReturn = jobDescriptions.map(({ materials = [] }) => {
      return materials.map((mat) => {
        return { ...mat, invoiceCode: refNumber };
      });
    });

    if (priceDifference) {
      materialsToReturn.push({
        category: "Surplus materials",
        invoiceCode: refNumber,
        itemRefPrice: priceDifference,
        materialCode: uid,
        materialDescription: "Surplus Materials",
        quantity: 1,
      });
    }

    return materialsToReturn;

    // console.log("hello", materialsReturned);

    // return jobDescriptions.map(({ materials = [] }) => {
    //   return materials.map((mat) => {
    //     return { ...mat, invoiceCode: refNumber };
    //   });
    // });
  });

  let flattenedMaterials = materialsData.flat(2);
  return flattenedMaterials;
}

function formatJobDetails(briefJobDetails = "", jobDescriptions = []) {
  let jobDetails = briefJobDetails + "<br>";
  jobDescriptions.forEach(({ jobDate = "-/-/-", details = "" }) => {
    jobDetails += "<br>" + dateTimeFormatter(jobDate, "d_full") + " " + details;
  });
  //console.log("formatred job details", jobDetails);
  return jobDetails;
}

function formatHours(jobDescriptions) {
  let hours = jobDescriptions.reduce((total, { hours = 0 }) => {
    return total + Number(hours);
  }, 0);

  //console.log("formattedHours", hours);
  return hours;
}

function formatAddress(ts) {
  let address = ts.address ? `${ts.address}, ` : "";
  let address2 = ts.address2 ? `${ts.address2}, ` : "";
  let flat = ts.flat ? `Flat ${ts.flat}, ` : "";
  let unit = ts.unit ? `Unit ${ts.unit}, ` : "";
  let city = ts.city ? `${ts.city}, ` : "";
  let postcode = ts.postcode ? `${ts.postcode}` : "";

  let formattedLocation = `${address}${address2}${flat}${unit}${city}${postcode}`;
  //console.log("formattedLocation", formattedLocation);
  return formattedLocation;
}

function calculateOpMultiplier(jobDescriptions) {
  //Loop through jobs and create an object of which operatives are present across
  //all jobs. Due to the Microsoft Access limitations, each job description with
  // more than 0 hours should have the same operatives present. Otherwise, the labour
  //total between the app and Access will be different. Default beahviour here is that
  //present object will contain an op if they are present on any job.
  let present = {};
  jobDescriptions.forEach((job) => {
    if (job.hours > 0) {
      for (let opId in job.operatives) {
        present[opId] = job.operatives[opId];
      }
    }
  });

  let multiplier = 0;
  for (let opId in present) {
    multiplier += Number(present[opId]);
  }

  return multiplier;
}

function formatHourRate(jobDescriptions) {
  //Take the first jobDescriptions rateAccessId and use it for the entire timesheet.
  //Not ideal but access only lets you use a single id. And messing around with the hours
  //or the multiplier is unacceptable. If no jobs, return 0 which will come up as blank in
  //access.
  let hourRate = 0;
  if (jobDescriptions.length > 0) {
    hourRate = jobDescriptions[0].rateAccessId;
  }

  return hourRate;
}

const Export = () => {
  const [csvData, setCsvData] = useState(null);
  //const [formattedTimesheets, setFormattedTimesheets] = useState([]);
  //const [associatedMaterials, setAssociatedMaterials] = useState([]);

  //Use useTimesheets here because you don't want the data changing while you are
  //deciding what to export
  const timesheets = useTimesheets(timesheetsRef);
  const quotes = useTimesheets(quotesRef);

  const [timesheetsToExport, setTimesheetsToExport] = useState([]);
  const [markedTimesheets, editMarkedTimesheets] = useState([]);

  const [sectionedTimesheets, setSectionedTimesheets] = useState([]);

  useEffect(() => {
    //Can't use useSectionedData here. Creates a recursive loop
    const allData = timesheets.concat(quotes);
    let sectionedData = section(allData);

    setSectionedTimesheets(sectionedData);
  }, [quotes, timesheets]);

  function isMarked(timesheetId) {
    let marked = false;
    if (markedTimesheets.includes(timesheetId)) {
      marked = true;
    }

    return marked;
  }

  async function formatAndExportTimesheets() {
    // Instead of creating a file and sending it through email. I will
    // just set up a table with all the info and he can copy it over.

    const fullTimesheets = await timesheetsToExport.map(async (ts) => {
      let dbRef = getDbRef(ts.primaryType);

      const jobsSnap = await getDocs(
        collection(dbRef, ts.uid, "jobDescriptions")
      );

      const jobDescriptions = [];

      //jobSnap.forEach is in built firestore method and is synchronous.

      jobsSnap.forEach((jobSnap) => {
        if (jobSnap.exists()) {
          let materialsWithInvoiceRef = jobSnap.data().materials.map((mat) => {
            return { ...mat, invoiceCode: ts.refNumber };
          });

          jobDescriptions.push({
            ...jobSnap.data(),
            materials: materialsWithInvoiceRef,
          });
        }
      });

      let jobDetails = formatJobDetails(ts.jobDetails, jobDescriptions);
      let hours = formatHours(jobDescriptions);
      let jobLocation = formatAddress(ts);
      let hourRate = formatHourRate(jobDescriptions);
      let multiplier = calculateOpMultiplier(jobDescriptions);

      let [materialsCost] = calcJobsMaterials(jobDescriptions);
      //let [materialsVat, materialsCost] = calcMaterialsVat(materialsCost);

      let primaryTypePrefix = "";
      if (ts.primaryType === "quote") {
        primaryTypePrefix = "Q - ";
      }

      return {
        blank: "",
        refNumber: `${primaryTypePrefix}${ts.refNumber}` ?? "",
        accessId: ts.accessId ?? "",
        worksOrderNumber: ts.worksOrderNumber ?? "",
        jobLocation,
        authorisedBy: ts.authorisedBy ?? "",
        invoiceDate: dateTimeFormatter(new Date(), "d_full"), //ts.invoiceDate ?? "",
        jobReceived: ts.jobReceived ?? "",
        jobStart: ts.jobStart ?? "",
        jobEnd: ts.jobEnd ?? "",
        jobDetails,
        hours,
        multiplier,
        discount: ts.discount ?? 0,
        hourRate,
        materialsCost: materialsCost,
        paid: ts.paid ?? false,
        datePaid: "",
        printSelector: true,
        dateSent: ts.dateSent ?? "",
        //Below are keys needed for calculations and formatting invoice
        primaryType: ts.primaryType ?? "",
        quotePrice: ts.quotePrice ?? null,
        priceDifference: ts.priceDifference ?? null,
        uid: ts.uid,
        jobDescriptions,
      };
    });

    const newTimesheets = await Promise.all(fullTimesheets);

    // let associatedMaterials = getAssociatedMaterials(newTimesheets);

    //setAssociatedMaterials([...associatedMaterials]);
    //setFormattedTimesheets([...newTimesheets]);
    saveToCsv(newTimesheets);
  }

  function saveToCsv(formattedTimesheets) {
    let flattenedMaterials = getAssociatedMaterials(formattedTimesheets);
    // console.log("flattenedMaterials", flattenedMaterials);

    let timesheetsParser = new Parser(timesheetFields);
    let materialsParser = new Parser(materialsFields);

    let timesheetsCsv =
      formattedTimesheets.length > 0
        ? timesheetsParser.parse(formattedTimesheets)
        : "no timesheets";

    let materialsCsv =
      flattenedMaterials.length > 0
        ? materialsParser.parse(flattenedMaterials)
        : "no materials";

    let universalBOM = "\uFEFF"; //Lets excel know to use utf-8 encoding. Called a Byte Order Mark (BOM)
    let encodedCsvUri = encodeURI(
      universalBOM +
        "Timesheets" +
        "\n\n" +
        timesheetsCsv +
        "\n\n\n" +
        "Materials" +
        "\n\n" +
        materialsCsv
    );

    // console.log("timesheets csv", encodedCsvUri);

    let file = "data: text/csv;charset=utf-8," + encodedCsvUri;
    // let file = "data:application/vnd.ms-excel" + encodedCsvUri;
    setCsvData(file);
  }

  function resetCsvData() {
    // Need to reset csv file data in case user believes picked file is included in previously
    // exported data.
    if (csvData) setCsvData(null);
  }

  function pickTimesheet(timesheet) {
    resetCsvData();

    let timesheetId = timesheet.uid;

    setTimesheetsToExport((exportTimesheets) => {
      if (isMarked(timesheetId)) {
        return exportTimesheets.filter(({ uid }) => uid !== timesheetId);
      } else {
        return [...exportTimesheets, timesheet];
      }
    });

    editMarkedTimesheets((marked) => {
      if (isMarked(timesheetId)) {
        return marked.filter((uid) => uid !== timesheetId);
      } else {
        return [...marked, timesheetId];
      }
    });
  }

  function pickMonth(timesheets) {
    resetCsvData();

    timesheets.forEach((ts) => {
      pickTimesheet(ts);
    });
  }

  return (
    <div className="exportPage">
      <Footer title="Export" back={false}>
        {/* <button className="adder" onClick={pdfView}>
          <PictureAsPdfIcon style={{ fontSize: 30 }} />
        </button> */}
        {/* 
        <button className="adder" onClick={toggleEditMode}>
          <EditIcon style={{ fontSize: 30 }} />
        </button>

        {showBin ? (
          <button onClick={removeJobDescriptions} className="adder">
            <DeleteOutlinedIcon style={{ fontSize: 30 }} />
          </button>
        ) : (
          <button onClick={addJobDescription} className="adder">
            <AddIcon style={{ fontSize: 30 }} />
          </button>
        )} */}
      </Footer>
      {/* <h2>Export</h2> */}
      {/* <button onClick={formatAndExportTimesheets}>export</button> */}

      {/* <button onClick={saveToCsv}>save</button> */}

      {/* <a type="text/csv" download={"timesheets.csv"} href={csvData}>
        csvData
      </a> */}

      <div className="exportTiles">
        {sectionedTimesheets.map(({ title, data }) => {
          return (
            <div className="exportTile" key={title}>
              <h4 onClick={() => pickMonth(data)} className="exportTitle">
                {title}
              </h4>

              {data.map((ts) => {
                let { refNumber, uid, primaryType } = ts;
                let dataType = primaryType === "timesheet" ? "T" : "Q";
                let marked = isMarked(uid);
                // console.log("data gg", ts);

                return (
                  <button
                    className="exportLine"
                    style={marked ? markedTimesheet : unmarkedTimesheet}
                    onClick={() => pickTimesheet(ts)}
                    key={uid}
                  >
                    {/* <p>{uid}</p> */}

                    <span className={`${dataType}type`}>{dataType}</span>
                    <span>{refNumber}</span>
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>

      <div className="primariesToExport">
        {timesheetsToExport.length > 0 && (
          <>
            <button onClick={formatAndExportTimesheets}>export</button>
            <a type="text/csv" download={"timesheets.csv"} href={csvData}>
              csvData
            </a>
          </>
        )}
        {timesheetsToExport.map(({ refNumber, uid }) => (
          <span key={uid}>{refNumber}</span>
        ))}
      </div>
    </div>
  );
};

export default Export;

// {
/* <>
      <table>
        <thead>
          <tr>
            <th>Blank</th>
            <th>invoiceNumber</th>
            <th>accountId</th>
            <th>yourReference</th>
            <th>jobLocation</th>
            <th>authorised</th>
            <th>invoiceDate</th>
            <th>jobReceived</th>
            <th>startDate</th>
            <th>endDate</th>
            <th>jobDescription</th>
            <th>hours</th>
            <th>multiplier</th>
            <th>discount</th>
            <th>hourRate</th>
            <th>materialsCost</th>
            <th>paid</th>
            <th>datePaid</th>
            <th>printSelector</th>
            <th>dateSent</th>
          </tr>
        </thead>
        <tbody>
          {formattedTimesheets.map(ts => {
            return (
              <tr key={ts.uid}>
                <td>{""}</td>
                <td name="invoiceNumber">{ts.refNumber}</td>
                <td name="accountId">{ts.accessId}</td>
                <td name="yourReference">{ts.worksOrderNumber}</td>
                <td name="jobLocation">{ts.jobLocation}</td>
                <td name="authorised">{ts.authorisedBy}</td>
                <td name="invoiceDate">{""}</td>
                <td name="jobReceived">{ts.jobReceived}</td>
                <td name="startDate">{ts.jobStart}</td>
                <td name="endDate">{ts.jobEnd}</td>
                <td name="jobDescription">{ts.jobDetails}</td>
                <td name="hours">{ts.hours}</td>
                <td name="multiplier">{ts.multiplier}</td>
                <td name="discount">{0}</td>
                <td name="hourRate">{ts.hourRate}</td>
                <td name="materialsCost">{ts.materialsCost}</td>
                <td name="paid">{String(ts.paid)}</td>
                <td name="datePaid">{""}</td>
                <td name="printSelector">{"true"}</td>
                <td name="dateSent">{""}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          { Empty footer allows easy copying of entire table. }
          <tr>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <h3>Matrials</h3>
      <table>
        <thead>
          <tr>
            <th>Blank</th>
            <th>invoiceCode</th>
            <th>materialDescription</th>
            <th>quantity</th>
            <th>itemRefPrice</th>
          </tr>
        </thead>
        <tbody>
          {associatedMaterials.map((material, i) => {
            return (
              <tr key={i}>
                <td>{""}</td>
                <td name="invoiceCode">{material.invoiceCode}</td>
                <td name="materialDescription">
                  {material.materialDescription}
                </td>
                <td name="quantity">{material.quantity}</td>
                <td name="itemRefPrice">{material.itemRefPrice}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          {Empty footer allows easy copying of entire table. }
          <tr>
            <td></td>
          </tr>
        </tfoot>
        </table>
        </> */
// }
